import angular, { auto } from 'angular'
import { RegisterManager } from '../managers/register-manager'
import { UserManager } from '../managers/user-manager'
import { RegistersResource } from '../components/register/registers-resource/registers-resource.service'
import { UsersStore } from '../factories/database/users-store'
import { PriceBookManager } from '../managers/price-book-manager'
import { TaxManager } from '../managers/tax-manager'
import { RetailerSettingsManager } from '../managers/retailer-settings-manager'
import { PosStateManager } from '../managers/pos-state-manager'
import { WebRegisterStatusManager } from '../managers/web-register-status-manager'
import { CustomerManager } from '../managers/customer-manager'

/**
 * Managers singleton ES6 instances
 */
export let registerManager: RegisterManager
export let userManager: UserManager
export let registersResource: RegistersResource
export let usersStore: UsersStore
export let priceBookManager: PriceBookManager
export let taxManager: TaxManager
export let retailerSettingsManager: RetailerSettingsManager
export let posStateManager: PosStateManager
export let webRegisterStatusManager: WebRegisterStatusManager
export let customerManager: CustomerManager

angular.module('webregister').run([
  '$injector',
  (i: auto.IInjectorService) => {
    registerManager = i.get('registerManager')
    userManager = i.get('userManager')
    registersResource = i.get('registersResource')
    usersStore = i.get('usersStore')
    priceBookManager = i.get('priceBookManager')
    posStateManager = i.get('posStateManager')
    taxManager = i.get('taxManager')
    retailerSettingsManager = i.get('retailerSettingsManager')
    webRegisterStatusManager = i.get('webRegisterStatusManager')
    customerManager = i.get('customerManager')
  },
])
